export interface StatusHistoryEntry {
  status: string;
  from: string | null;
  at: string;
  by: number | null;
  message: string | null;
  meta: Record<string, unknown> | null;
  user?: {
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    avatar?: string | null;
  } | null;
}

/** Returns the first history entry where the status matches. */
export function findHistoryEntry(
  history: StatusHistoryEntry[] | null | undefined,
  status: string,
): StatusHistoryEntry | undefined {
  return history?.find((e) => e.status === status);
}

/** Returns the last history entry where the status matches. */
export function findLastHistoryEntry(
  history: StatusHistoryEntry[] | null | undefined,
  status: string,
): StatusHistoryEntry | undefined {
  if (!history) return undefined;
  for (let i = history.length - 1; i >= 0; i--) {
    if (history[i].status === status) return history[i];
  }
  return undefined;
}

/** Shorthand: returns the `at` timestamp for a status transition, or null. */
export function historyTimestamp(
  history: StatusHistoryEntry[] | null | undefined,
  status: string,
): string | null {
  return findHistoryEntry(history, status)?.at ?? null;
}

/** Returns the message recorded for a status transition (first match), or null. */
export function historyMessage(
  history: StatusHistoryEntry[] | null | undefined,
  status: string,
): string | null {
  return findHistoryEntry(history, status)?.message ?? null;
}

/** Returns the message from the last entry for a status (guards against repeated transitions), or null. */
export function historyLastMessage(
  history: StatusHistoryEntry[] | null | undefined,
  status: string,
): string | null {
  return findLastHistoryEntry(history, status)?.message ?? null;
}
